"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var typeTemplate = '${label}不是一个有效的${type}';
var common = {
  reset: '重置',
  cancel: '取消',
  confirm: '确定',
  noData: '暂无数据',
  noSearchResult: '暂无搜索结果'
};
var _default = exports.default = {
  AutoComplete: {
    placeholder: '请输入',
    noData: '暂无搜索结果'
  },
  FileInput: {
    placeholder: '请选择文件',
    remove: '移除',
    choice: '选择'
  },
  Upload: {
    defaultError: '上传失败'
  },
  ImageUpload: {
    upload: '点击上传',
    uploadAgain: '点击重新上传'
  },
  Loading: {
    text: '正在加载'
  },
  Modal: {
    openText: '确 定',
    closeText: '取 消'
  },
  Select: {
    placeholder: '请选择',
    noData: '暂无搜索结果',
    noChoice: '暂无选项',
    etc: '等',
    indivual: '个'
  },
  Cascader: {
    noData: '暂无数据',
    noMatch: '无匹配数据'
  },
  Mark: {
    texts: ['极差', '失望', '一般', '满意', '惊喜']
  },
  DatePicker: {
    monthText: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    quarter: ['Q1', 'Q2', 'Q3', 'Q4'],
    halfYear: ['H1', 'H2'],
    daysText: ['一', '二', '三', '四', '五', '六', '日'],
    placeholder: '请选择时间',
    selectStartPlaceholder: '开始时间',
    selectEndPlaceholder: '结束时间',
    selectMonthText: '请选择月',
    selectYearText: '请选择年',
    week: '周',
    dayjsLocal: 'zh-cn'
  },
  ImageView: {
    zoomIn: '放大',
    zoomOut: '缩小',
    prev: '前一张',
    next: '后一张',
    rotateLeft: '旋转',
    reset: '还原',
    close: '关闭',
    noData: '暂无图片数据',
    download: '下载',
    rotateY: '翻转'
  },
  Pagination: {
    itemsPerPage: '条/页',
    jumpTo: '到第',
    jump: '跳转',
    page: '页'
  },
  Table: {
    filterSearchPlaceholder: '搜索筛选项',
    filterReset: '重置',
    filterConfirm: '确定',
    filterEmptyText: '无筛选项',
    filterCheckall: '全选',
    filterCheckNotall: '全不选',
    noData: '暂无数据',
    triggerDesc: '点击降序',
    triggerAsc: '点击升序',
    cancelSort: '取消排序',
    columnSet: '列设置',
    columnShow: '列展示',
    columnReset: '重置',
    fixedColumn: '固定该列',
    fixedLeft: '固定左侧',
    fixedRight: '固定右侧',
    fixedCancel: '取消固定',
    fixedForbid: '固定列不可操作'
  },
  MultiCascader: {
    placeholder: '请选择',
    checkAll: '全部',
    searchPlaceholder: '搜索',
    noResultsText: '暂无匹配结果',
    checkAllButtonText: '全部',
    noData: '暂无数据'
  },
  TreeSelect: {
    searchPlaceholder: '搜索',
    noData: '暂无数据'
  },
  Form: {
    optional: '（可选）'
  },
  FormPro: {
    optional: '（可选）',
    defaultValidateMessages: {
      default: '字段验证错误${label}',
      required: '请输入${label}',
      enum: '${label}必须是其中一个[${enum}]',
      whitespace: '${label}不能为空字符',
      date: {
        format: '${label}日期格式无效',
        parse: '${label}不能转换为日期',
        invalid: '${label}是一个无效日期'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label}须为${len}个字符',
        min: '${label}最少${min}个字符',
        max: '${label}最多${max}个字符',
        range: '${label}须在${min}-${max}字符之间'
      },
      number: {
        len: '${label}必须等于${len}',
        min: '${label}最小值为${min}',
        max: '${label}最大值为${max}',
        range: '${label}须在${min}-${max}之间'
      },
      array: {
        len: '须为${len}个${label}',
        min: '最少${min}个${label}',
        max: '最多${max}个${label}',
        range: '${label}数量须在${min}-${max}之间'
      },
      pattern: {
        mismatch: '${label}与模式不匹配${pattern}'
      }
    }
  },
  ImageEdit: {
    reset: '重置',
    cancel: '取消',
    confirm: '确定',
    replace: '更换',
    imageUpload: '上传图片',
    picturePreview: '图片预览',
    imgClearVisible: '※ 请确保图片清晰可见',
    imgScale: '按比例裁剪',
    zoomIn: '放大',
    zoomOut: '缩小',
    rotateLeft: '旋转',
    cropSize: '当前裁剪尺寸: '
  },
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: '收起',
    expand: '展开'
  },
  OrganizationPicker: (0, _assign.default)((0, _assign.default)({}, common), {
    prompt: '提示',
    fail: '获取失败',
    chosen: '您已选择',
    items: '项',
    click: '点击查看',
    org: '组织结构',
    chose: '选择组织结构',
    search: '搜索组织结构',
    pleaseChose: '请选择',
    searchContent: '搜索内容',
    loading: '正在加载',
    chosenItems: '已选项',
    empty: '清空所选',
    city: '城市',
    cityGroup: '城市组'
  }),
  Evaluation: {
    title: '以上功能是否对您有帮助？',
    likeDesc: '很赞，鼓励一下',
    dislikeDesc: '不好，继续优化',
    feedbackDesc: '提点意见'
  },
  MultiTableSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    rightText: '已选数据',
    labelText: '请输入',
    search: '查询'
  }),
  MultiTabSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    maxSelected: '最多可选择',
    ge: '个',
    choose: '已选',
    empty: '清空已选',
    chooseAll: '全选',
    labelText: '请输入',
    confirmEmpty: '确定清空'
  }),
  CountDown: {
    confirm: '确认',
    second: '秒'
  },
  DateSelect: {
    customBtnText: "自定义",
    leftRadioText: ['昨日', '近7日', '近30日', '本月'],
    DefaultRightSelectorText: ['按日', '按周', '按月']
  },
  DynamicForm: {
    newData: ' 新建内容',
    clearData: '将清空全部填充内容',
    delete: '删除',
    copy: '复制',
    down: '顺序向下',
    up: '顺序向上',
    max: '最多可添加',
    item: '项',
    clearGroup: '清除组'
  },
  MisSearch: {
    noSearchResult: common.noSearchResult
  }
};